module.exports = __webpack_public_path__ + "static/gabriela-amarie-ed127b355c9a6f0ed1b3ae7f3bc8d907.jpg";